<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="250">
        <v-card>
            <v-card-title><span class="headline">構造事前検討依頼({{cadRequestBasicInformation.house_name}})</span></v-card-title>
            <v-container>
                <v-card-text class="ma-0 pa-0">
                    <v-row no-gutters>
                        <!-- :disabled="cadRequestBasicInformation.basic_specification != 1" -->
                        <!-- OPTION_1 -->
                        <v-col cols="12">
                            <v-radio-group  dense row v-model="OPTION_1" >
                                <v-radio label="あり" value="あり"></v-radio>
                                <v-radio label="なし" value="なし"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <!-- OPTION_ZEH -->
                        <v-col cols="12"><span style="font-size:18px;" v-if="OPTION_1 == 'あり' || OPTION_1 == null">構造検討依頼</span></v-col>
                        <!-- {{cadRequestBasicInformation.basic_specification}} -->
                        <v-col cols="6"><v-checkbox dense label="ZEHあり" v-if="OPTION_1 == 'あり' || OPTION_1 == null" v-model="OPTION_ZEH" @change="handleCheckboxChange('ZEH')"></v-checkbox></v-col>
                        <v-col cols="6"><v-checkbox dense label="GXあり" v-if="OPTION_1 == 'あり' || OPTION_1 == null" v-model="OPTION_GX" @change="handleCheckboxChange('GX')"></v-checkbox></v-col>

                        <!-- OPTION_2 -->
                        <v-col cols="12" v-if="cadRequestBasicInformation.house_type_category == 2"><span style="font-size:18px;" v-if="OPTION_1 == 'あり' || OPTION_1 == null">ダクト指示</span></v-col>
                        <v-col cols="12" v-if="cadRequestBasicInformation.house_type_category == 2">
                            <v-radio-group dense row v-model="OPTION_2" v-if="OPTION_1 == 'あり' || OPTION_1 == null" :disabled="isOption2Disabled">
                                <v-radio label="あり" value="あり"></v-radio>
                                <v-radio label="なし" value="なし"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <!-- OPTION_W -->
                        <v-col cols="12"><span style="font-size:18px;" v-if="OPTION_1 == 'あり' || OPTION_1 == null">等級</span></v-col>
                        <v-col cols="6">
                            <v-autocomplete v-model="OPTION_W" dense outlined label="耐風" v-if="OPTION_1 == 'あり' || OPTION_1 == null" :items="['W1', 'W2']" clearable></v-autocomplete>
                        </v-col>

                        <!-- OPTION_S -->
                        <v-col cols="6">
                            <v-autocomplete v-model="OPTION_S" dense outlined label="積雪" v-if="OPTION_1 == 'あり' || OPTION_1 == null" :items="['S1', 'S2']" clearable></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="success" v-if="cadRequestBasicInformation.house_type_category == 2" :disabled="(cadRequestBasicInformation.house_type_category == 2 && OPTION_1 == null && OPTION_2 == null) || (OPTION_1 == 'あり' && OPTION_2 == null)" @click="confirmStructuralRequest()">保存</v-btn>
                <v-btn dark color="success" v-else :disabled="(cadRequestBasicInformation.house_type_category == 3 && OPTION_1 == null)" @click="confirmStructuralRequest()">保存</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        dialog: Boolean
    },

    data(){
        return {
            OPTION_ZEH: false,
            OPTION_GX: false,
            OPTION_1: null,
            OPTION_2: null,
            OPTION_W: null,
            OPTION_S: null,
            isOption2Disabled: true

        }
    },
    computed: {
        ...mapState([
            'cadRequestBasicInformation',
            'structural_request',
            'structOrStop',
        ]),
    },
    methods: {
        handleCheckboxChange(selected) {
            if (selected === 'ZEH') {
                this.OPTION_GX = false; // Uncheck GX if ZEH is checked
            } else if (selected === 'GX') {
                this.OPTION_ZEH = false; // Uncheck ZEH if GX is checked
            }
        },

        toggleDialogStructuralRequest(value){
            this.$emit('toggleDialogStructuralRequest', value)
        },

        confirmStructuralRequest(){
            this.$emit('confirmStructuralRequest', {
                OPTION_ZEH: this.OPTION_ZEH,
                OPTION_GX: this.OPTION_GX,
                OPTION_1: this.OPTION_1,
                OPTION_2: this.OPTION_2,
                OPTION_W: this.OPTION_W,
                OPTION_S: this.OPTION_S,
            })

            this. toggleDialogStructuralRequest(false)
        }
    },

    watch: {
        dialog(val){
            if(this.cadRequestBasicInformation.basic_specification == 1){
                this.OPTION_ZEH = true;
            }
                if(this.cadRequestBasicInformation.house_type_category == 2){
                    this.cadRequestBasicInformation.house_name ='枠組';
                }else if(this.cadRequestBasicInformation.house_type_category == 3){
                    this.cadRequestBasicInformation.house_name ='軸組';
                    this.OPTION_2 = null;
                }

        },
        '$store.state.structural_request'(val){
            // console.log(val, 'val')
                this.OPTION_ZEH = val.OPTION_ZEH;
                this.OPTION_GX = val.OPTION_GX;
                this.OPTION_1 = val.OPTION_1;
                this.OPTION_2 = val.OPTION_2;
                this.OPTION_W = val.OPTION_W;
                this.OPTION_S = val.OPTION_S;
        },
        OPTION_1(val){
            if(val == 'なし'){
                this.OPTION_2 = null;
                this.OPTION_S = null;
                this.OPTION_W = null;
                this.isOption2Disabled = true;
            }else if(val == 'あり'){
                this.isOption2Disabled = false;

            }
        }
    }
}
</script>

<style>

</style>